// https://github.com/elastic/apm-agent-rum-js/issues/1185#issuecomment-1481208219
import { afterFrame } from '@elastic/apm-rum-core';
import { useRouter } from 'next/router';
import React, { useEffect, useMemo } from 'react';

interface ApmTransactionProps {
  children: React.ReactNode;
  apm: any; // Replace 'any' with the actual type of 'apm' if possible
}

const ApmTransaction: React.FC<ApmTransactionProps> = ({ children, apm }) => {
  const router = useRouter();

  const transaction = useMemo(() => {
    if (!apm) return;
    // eslint-disable-next-line consistent-return
    return apm.startTransaction(router.asPath, 'route-change', {
      managed: true,
      canReuse: true
    });
  }, [apm, router.asPath]);

  useEffect(() => {
    if (!transaction) return;
    afterFrame(() => transaction && transaction?.detectFinish());
    // eslint-disable-next-line consistent-return
    return () => {
      /**
       * Incase the transaction is never ended, we check if the transaction
       * can be closed during unmount phase
       *
       * We call detectFinish instead of forcefully ending the transaction
       * since it could be a redirect route and we might prematurely close
       * the currently running transaction
       */
      // eslint-disable-next-line no-unused-expressions
      transaction && transaction?.detectFinish();
    };
  }, [transaction]);

  return <>{children}</>;
};

export default ApmTransaction;
